import { Box } from "@mui/material"
import type { ReactElement } from "react"
import React from "react"

import ContactCardTitle from "@/screens/Companies/edit/components/locations/components/ContactCardTitle"

const LocationContactMethods = ({
  phoneNumber,
  altPhoneNumber,
  faxNumber,
  handleEditLocationContactMethods,
}: {
  phoneNumber?: string | null
  altPhoneNumber?: string | null
  faxNumber?: string | null
  handleEditLocationContactMethods: () => void
}): ReactElement => {
  return (
    <>
      <Box className='flex items-center p-4'>
        <ContactCardTitle
          title='Location Contact Methods'
          label='Edit Location Contact Methods'
          onClick={handleEditLocationContactMethods}
        />
      </Box>
      <Box className='flex flex-row justify-evenly gap-x-12 px-4 pb-6'>
        <Box className='flex items-start'>
          <span className='capitalize text-gray-900'>Phone {phoneNumber ?? "-"}</span>
        </Box>
        <Box className='flex items-start'>
          <span className='capitalize text-gray-900'>Alt phone {altPhoneNumber ?? "-"}</span>
        </Box>
        <Box className='flex items-start'>
          <span className='uppercase text-gray-900'>FAX {faxNumber ?? "-"}</span>
        </Box>
      </Box>
    </>
  )
}

export default LocationContactMethods
